import { moduleWebOrigin, URLS } from "@itaas/ports";
import { resolveModuleHandoffBaseUrl } from "@itaas/core/config/suite-module-handoff";
import {
  getModuleDefaultPath,
  MODULE_HANDOFF_SPECS,
} from "@itaas/core/modules/module-handoff-config";
import { SUITE_MODULE_REGISTRY } from "@itaas/core/modules/registry";

export const IAM_API_BASE_URL =
  import.meta.env.VITE_IAM_API_BASE_URL ?? "/api/iam";

export const IAM_TENANT_SLUG =
  import.meta.env.VITE_IAM_TENANT_SLUG ?? "demo";

const MODULE_URL_ENV: Record<string, string | undefined> = {
  product: import.meta.env.VITE_PRODUCT_URL,
  inventory: import.meta.env.VITE_INVENTORY_URL,
  autoid: import.meta.env.VITE_AUTOID_URL,
  erp: import.meta.env.VITE_ERP_URL,
  rh: import.meta.env.VITE_RH_URL,
  workforce: import.meta.env.VITE_WORKFORCE_URL,
  recruitment: import.meta.env.VITE_RECRUITMENT_URL,
  attendance: import.meta.env.VITE_ATTENDANCE_URL,
  security: import.meta.env.VITE_SECURITY_URL,
  notifications: import.meta.env.VITE_NOTIFICATIONS_URL,
  billing: import.meta.env.VITE_BILLING_URL,
  crm: import.meta.env.VITE_CRM_URL,
  finance: import.meta.env.VITE_FINANCE_URL,
  procurement: import.meta.env.VITE_PROCUREMENT_URL,
  hospitol: import.meta.env.VITE_HOSPITOL_URL,
  edu: import.meta.env.VITE_EDU_URL,
  mineportal: import.meta.env.VITE_MINEPORTAL_URL,
  subportal: import.meta.env.VITE_SUBPORTAL_URL,
  comex: import.meta.env.VITE_COMEX_URL,
  legal: import.meta.env.VITE_LEGAL_URL,
};

/** Défauts dev depuis @itaas/ports + module-handoff-config (Kanakku split). */
function devDefaultUrl(moduleId: string): string | undefined {
  const spec = MODULE_HANDOFF_SPECS[moduleId];
  if (spec) {
    try {
      return moduleWebOrigin(spec.portProduct);
    } catch {
      return undefined;
    }
  }
  const legacy: Record<string, string | undefined> = {
    autoid: URLS.AUTOID_WEB,
    erp: URLS.ERP_WEB,
    rh: URLS.RH_WEB,
    security: URLS.SECURITY_WEB,
    notifications: URLS.ERP_WEB,
    hospitol: URLS.HOSPITOL_WEB,
    edu: URLS.EDU_WEB,
    mineportal: URLS.MINEPORTAL_WEB,
    subportal: URLS.SUBPORTAL_WEB,
    comex: URLS.COMEX_WEB,
    legal: URLS.LEGAL_WEB,
  };
  return legacy[moduleId];
}

export function getModuleBaseUrl(moduleId: string): string {
  return resolveModuleHandoffBaseUrl({
    moduleId,
    envUrl: MODULE_URL_ENV[moduleId],
    devDefault: devDefaultUrl(moduleId),
  });
}

/** URLs de base de tous les modules (pour purge SSO cross-origin à la déconnexion). */
export function listModuleBaseUrls(): string[] {
  return SUITE_MODULE_REGISTRY.map((entry) => getModuleBaseUrl(entry.id));
}

export { getModuleDefaultPath };
